import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-flow: column nowrap;

  p {
    text-align: center;
  }
`;

export const Title = styled.div`
  font-size: 2.5em;
  font-weight: bold;
  text-align: center;
  color: var(--title-text);
  margin: 0.2em 0;
`;

export const Nope = styled.div`
  z-index: var(--base-z-index);
  width: 300px;
  height: 300px;
  margin: 1em auto;
  border-radius: 50%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
  background-image: url('/public/images/accessdenied.gif');
`;
